export const validator = {
  telnumber: /^1[1234567890]\d{9}$/, // 手机号码格式
  phonenumber: /^((0\d{2,3})-)(\d{7,8})$/, // 固定电话格式
  normalnumber: /^((0\d{2,3}-\d{7,8})|(1[1234567890]\d{9}))$/, // 不详细验证，只要11位或12位的数字。用于校验固定电话+手机号形式
  idcard: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, // 身份证号码
  version: /^([a-zA-Z]+)-(\d+(\.\d+){3})$/, // 版本号
  versionCode: /^\d(\.\d{1,2}){3}$/, // 版本管理新增版本号校验
  roleName: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/, // 角色名称
  // account: /^(\d|\w)+$/, // 检测账号是否只由英文和数字组成
  account: /^(\d|[a-zA-Z])+$/, // 检测账号是否只由英文和数字组成
  chinese: /^[\u4E00-\u9FA5]+$/, // 只包含中文字符
  url: /^(http:\/\/\.*)|(https:\/\/\.*)/,
  intnumber: /^([1-9]\d*)$/, // 除0以外的正整数
  zeroAndnumber: /^(\d*)$/, // 0和正整数
  number: /^\d+(\.\d+)?$/, // 非负浮点数
  number_100: /^([-]{0,1}\d{0,2}[0]{0,1})$/,
  zoneName: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, // 字母，数字，汉字，
  range: /(^[1-9]([0-9]*)$|^[0-9]$)/, // 输入值能为0，两位以上首位不能为0
  price: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, // 不小于0的数值
  area: /^(([1-9][0-9]*)|(([0]\.\d{1,4}|[1-9][0-9]*\.\d{1,4})))$/, // 房源面积
  rent: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, // 租金
  mail: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, // 邮箱
  VehicleNumber: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/, // 校验车牌号
  newVehicleNumber: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/, // 校验车牌号(新能源)
  TelephoneConsultation: /(^\d(\d|-)*\d$)/,
  priceCheck: /^((0)|([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, // 0或最多两位小数点
  priceCheck6: /^((0)|([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,6})))$/, // 0或最多六位小数点
  hundredNumber: /^(\d|[1-9]\d|100)(\.\d{1,2})?$/
}



// WEBPACK FOOTER //
// ./src/area-base/utils/validate.js